import { defineMessages } from 'react-intl';

export default defineMessages({
  currency: {
    id: 'currency',
    description: 'USD',
    defaultMessage: 'USD',
  },
  priceBandAbbrvLabel: {
    id: 'pbAbbreviation',
    description: 'PB',
    defaultMessage: 'PB',
  },
  suggestedTemplatesLabel: {
    id: 'comparisonChart.suggestedTemplates',
    description: 'Suggested Templates',
    defaultMessage: 'Suggested Templates',
  },
  selectedTemplatesLabel: {
    id: 'comparisonChart.selectedTemplates',
    description: 'Selected Templates',
    defaultMessage: 'Selected Templates',
  },
  clearFiltersLabel: {
    id: 'clearFilters',
    description: 'Clear Filters',
    defaultMessage: 'Clear Filters',
  },
  quantityAbbrvLabel: {
    id: 'quantityAbbrv',
    description: 'Qty',
    defaultMessage: 'Qty',
  },
});
